import { determineEnv } from "@fd/common/api/determineEnv";
import Gleap from "gleap";
import { getUser } from "./auth/user";

export let gleap: typeof Gleap | undefined = undefined;

if (determineEnv() === "prod") {
  Gleap.initialize("CWj4jRuTVZQUzLwHAC06nEUK0nfLudLh");
  getUser().then((user) => {
    if (user) Gleap.identify(user.id, { email: user.email });
  });

  gleap = Gleap;
}
